import React from 'react';
import MangosImage from '../../../images/mangoswap.png';
import './RealatedStartup.css';
const RealatedStartup = () => {
    return (
        <div className="realted-startup d-flex justify-content-center align-items-center">
            <div className="mangoswap realted-startup-card">
                <div className="mangoswap-head d-flex justify-content-center realted-startup-head">
                    <img src={MangosImage} alt="" />
                    <h4>Mangoswap</h4>
                </div>

                <div className="found d-flex justify-content-around realted-startup-price">
                    <p>Fund raise</p>
                    <p className="parcent">50% complete</p>
                </div>

                <div className="d-flex flex-column justify-content-center">
                    <div className="price realted-startup-bottom">
                        <h5>$200,000/$400,000</h5>
                    </div>
                    <div className=" realted-startup-hr">
                    </div>
                </div>
            </div>

            <div className="mangoswap realted-startup-card">
                <div className="mangoswap-head d-flex justify-content-center realted-startup-head">
                    <img src={MangosImage} alt="" />
                    <h4>Mangoswap</h4>
                </div>

                <div className="found d-flex justify-content-around realted-startup-price">
                    <p>Fund raise</p>
                    <p className="parcent">50% complete</p>
                </div>

                <div className="d-flex flex-column justify-content-center">
                    <div className="price realted-startup-bottom">
                        <h5>$200,000/$400,000</h5>
                    </div>
                    <div className=" realted-startup-hr">
                    </div>
                </div>
            </div>

            <div className="mangoswap realted-startup-card">
                <div className="mangoswap-head d-flex justify-content-center realted-startup-head">
                    <img src={MangosImage} alt="" />
                    <h4>Mangoswap</h4>
                </div>

                <div className="found d-flex justify-content-around realted-startup-price">
                    <p>Fund raise</p>
                    <p className="parcent">50% complete</p>
                </div>

                <div className="d-flex flex-column justify-content-center">
                    <div className="price realted-startup-bottom">
                        <h5>$200,000/$400,000</h5>
                    </div>
                    <div className=" realted-startup-hr">
                    </div>
                </div>
            </div>

            <div className="mangoswap realted-startup-card">
                <div className="mangoswap-head d-flex justify-content-center realted-startup-head">
                    <img src={MangosImage} alt="" />
                    <h4>Mangoswap</h4>
                </div>

                <div className="found d-flex justify-content-around realted-startup-price">
                    <p>Fund raise</p>
                    <p className="parcent">50% complete</p>
                </div>

                <div className="d-flex flex-column justify-content-center">
                    <div className="price realted-startup-bottom">
                        <h5>$200,000/$400,000</h5>
                    </div>
                    <div className=" realted-startup-hr">
                    </div>
                </div>
            </div>
        </div>

    );
};

export default RealatedStartup;